<template>
  <div v-if="order.meta && order.meta.shippings">
    <b-card>
      <b-form-row>
        <b-col cols="6">
          <b-form inline>
            <label class="mr-sm-2" for="pickupDelay" v-translate>Interval Between Pickups</label>
            <b-input type="number" id="pickupDelay" v-model="pickupDelay"></b-input>
          </b-form>
        </b-col>
        <b-col cols="6">
          <b-form inline>
            <label class="mr-sm-2" for="estimatedDriveTime" v-translate>Estimated Drive Time</label>
            <b-input type="number" id="estimatedDriveTime" v-model="estimatedDriveTime"></b-input>
          </b-form>
        </b-col>
      </b-form-row>
    </b-card>

    <b-card v-for="(shipping, index) in order.meta.shippings" :key="'shipping-' + index">
      <h5 v-translate="{number: index + 1}">Shipment %{number}</h5>
      <b-form-row class="mb-3">
        <b-col sm="4" lg="3">
          <label :for="'pickup-date' + index" class="col-form-label" v-translate>Estimated Pickup Date</label>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-input :id="'pickup-date' + index" type="date" v-model="shipping.estimated_pickup_dateDateTimeParts[0]" />
            </b-col>
            <b-col>
              <b-form-input type="time" v-model="shipping.estimated_pickup_dateDateTimeParts[1]" />
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>
      <b-form-row class="mb-3">
        <b-col sm="4" lg="3">
          <label :for="'pickup-note' + index" class="col-form-label" v-translate>Pickup Note</label>
        </b-col>
        <b-col>
          <b-form-textarea :id="'pickup-note' + index" v-model="shipping.pickup_note" />
        </b-col>
      </b-form-row>
      <b-form-row class="mb-3">
        <b-col sm="4" lg="3">
          <label :for="'delivery-date' + index" class="col-form-label" v-translate>Estimated Delivery Date</label>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-input :id="'delivery-date' + index" type="date" v-model="shipping.estimated_delivery_dateDateTimeParts[0]" />
            </b-col>
            <b-col>
              <b-form-input type="time" v-model="shipping.estimated_delivery_dateDateTimeParts[1]" />
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>
      <b-form-row class="mb-3">
        <b-col sm="4" lg="3">
          <label :for="'delivery-note' + index" class="col-form-label" v-translate>Delivery Note</label>
        </b-col>
        <b-col>
          <b-form-textarea :id="'delivery-note' + index" v-model="shipping.delivery_note" />
        </b-col>
      </b-form-row>
    </b-card>

    <b-card class="mb-0">
      <h5 v-translate>Purchase Orders</h5>
      <div v-for="(purchaseOrder, index) in order.meta.purchase_orders" :key="'order-' + index">
        <b-input-group class="mb-3">
          <b-input type="text" v-model="order.meta.purchase_orders[index]" />
          <b-input-group-append>
            <b-button size="sm" variant="success" :disabled="!order.meta.purchase_orders[index]" v-if="index === order.meta.purchase_orders.length - 1" @click="order.meta.purchase_orders.push('')"><strong>＋</strong></b-button>
            <b-button size="sm" variant="danger" :disabled="!order.meta.purchase_orders[index]" v-if="order.meta.purchase_orders.length > 1" @click="order.meta.purchase_orders.splice(index, 1)">✕</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'EditFieldMeta',
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pickupDelay: null,
      estimatedDriveTime: null,
      settingDelay: false
    }
  },
  computed: {
    firstPickupDate() {
      return this.order?.meta?.shippings[0]?.estimated_pickup_date
    }
  },
  watch: {
    'order.meta.shippings': {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          for (let index = 0; index < newValue.length; index++) {
            const shipping = newValue[index]
            if (!this.order.meta.shippings[index].estimated_pickup_dateDateTimeParts) {
              this.$set(this.order.meta.shippings[index], 'estimated_pickup_dateDateTimeParts', (shipping.estimated_pickup_date
                ? [
                    shipping.estimated_pickup_date.split(' ')[0],
                    shipping.estimated_pickup_date.split(' ')[1] || '00:00'
                  ]
                : ['', '00:00']))
            }
            if (!this.order.meta.shippings[index].estimated_delivery_dateDateTimeParts) {
              this.$set(this.order.meta.shippings[index], 'estimated_delivery_dateDateTimeParts', (shipping.estimated_delivery_date
                ? [
                    shipping.estimated_delivery_date.split(' ')[0],
                    shipping.estimated_delivery_date.split(' ')[1] || '00:00'
                  ]
                : ['', '00:00']))
            }
            this.order.meta.shippings[index].estimated_pickup_date = this.order.meta.shippings[index].estimated_pickup_dateDateTimeParts[0] ? this.moment.tz(this.order.meta.shippings[index].estimated_pickup_dateDateTimeParts.join(' '), this.$tz).utc().format('YYYY-MM-DD HH:mm:ss') : null
            this.order.meta.shippings[index].estimated_delivery_date = this.order.meta.shippings[index].estimated_delivery_dateDateTimeParts[0] ? this.moment.tz(this.order.meta.shippings[index].estimated_delivery_dateDateTimeParts.join(' '), this.$tz).utc().format('YYYY-MM-DD HH:mm:ss') : null
          }
        }
      }
    },
    firstPickupDate: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          if (!this.settingDelay && this.pickupDelay) {
            this.setPickupDelay()
          }
          if (!this.settingDelay && this.estimatedDriveTime) {
            this.setDriveTime()
          }
        }
      }
    },
    pickupDelay(val) {
      this.setPickupDelay()
      this.setDriveTime()
    },
    estimatedDriveTime(val) {
      this.setDriveTime()
    }
  },
  methods: {
    setPickupDelay() {
      if (this.pickupDelay && !this.settingDelay) {
        for (let i = 1; i < this.order.meta.shippings.length; i++) {
          this.settingDelay = true
          const prevShipping = this.order.meta.shippings[i - 1]
          if (prevShipping.estimated_pickup_date) {
            this.order.meta.shippings[i].estimated_pickup_date = this.moment.utc(prevShipping.estimated_pickup_date).add(this.pickupDelay, 'minutes').utc().format('YYYY-MM-DD HH:mm:ss')
            this.order.meta.shippings[i].estimated_pickup_dateDateTimeParts = this.moment.utc(this.order.meta.shippings[i].estimated_pickup_date).tz(this.$tz).format('YYYY-MM-DD HH:mm:ss').split(' ')
          }
        }
        this.settingDelay = false
      }
    },
    setDriveTime() {
      if (this.estimatedDriveTime && !this.settingDelay) {
        let i = 0
        for (const shipping of this.order.meta.shippings) {
          this.settingDelay = true
          if (shipping.estimated_pickup_date) {
            this.order.meta.shippings[i].estimated_delivery_date = this.moment.utc(shipping.estimated_pickup_date).add(this.estimatedDriveTime, 'minutes').utc().format('YYYY-MM-DD HH:mm:ss')
            this.order.meta.shippings[i].estimated_delivery_dateDateTimeParts = this.moment.utc(this.order.meta.shippings[i].estimated_delivery_date).tz(this.$tz).format('YYYY-MM-DD HH:mm:ss').split(' ')
          }
          i++
        }
        this.settingDelay = false
      }
    }
  }
}
</script>
